import { defineMessages } from "react-intl";

import { validator } from "lib/build/forms/basic-health/risks/socialWorkerReview";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	socialWorkerReview: {
		id: "form.social_worker_review",
		defaultMessage: "Környezettanulmány"
	},
	description: {
		id: "form.social_worker_review.description",
		defaultMessage: "Szöveges összefoglaló"
	}
});

const fields: { [key: string]: FieldData } = {
	description: {
		type: "field",
		path: ["description"],
		label: messages.description,
		errorMessages: genericErrorMessages,
		input: { type: "textarea", props: {} }
	}
};

const fieldset: FieldsetData = {
	rows: [{ columns: [{ width: 12, field: fields.description }] }]
};

export const node: LeafNode = {
	id: "bh_socialWorkerReview",
	value: {
		schemaId: "socialWorkerReview",
		title: messages.socialWorkerReview,
		validator,
		fieldset,
		isImportant: true,
		applyCurrentDate: true,
		defaults: [
			{
				path: ["description"],
				query: {
					interpretation: {
						vocab: "basic_health",
						code: "social_worker_review"
					}
				}
			}
		]
	}
};
